export const UnitViewsTypeIdEnum = {
  lookupTypeId: 142,
};
